import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persist'

// const pinia = createPinia();
// pinia.use(piniaPersist)

createApp(App).use(router).use(createPinia().use(piniaPersist)).mount('#app')
